import { createSlice } from '@reduxjs/toolkit';
import { productApi } from '#services/product';

import { revertAll } from '../actions';

interface CollectionEditState {
  filter: string;
  filterKey: string;
  order: string;
  orderBy: string;
  pageIndex: number;
  rows: unknown[];
  rowCount: number;
  pageSize: number;
  vendors: Record<string, unknown>;
  searchProducts: unknown[];
}

const PAGE_SIZE = 30;
const initialState: CollectionEditState = {
  // fields not used
  filter: '',
  filterKey: '',
  order: 'asc',
  orderBy: 'name',
  pageIndex: 0,
  rows: [],
  rowCount: 0,
  pageSize: PAGE_SIZE,
  vendors: {},

  // only this field is used
  searchProducts: [],
};

const handleProductsSearchingFulfilled = (
  state: CollectionEditState,
  action: { payload: unknown },
) => {
  const { rows } = action.payload as { rows?: unknown[] };
  state.searchProducts = rows || [];
};

export const collectionEditSlice = createSlice({
  name: 'collectionList',
  initialState,
  reducers: {
    clearSearchProducts(state) {
      state.searchProducts = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(revertAll, () => initialState)
      .addMatcher(
        productApi.endpoints.getProductsForSearching.matchFulfilled,
        handleProductsSearchingFulfilled,
      );
  },
});

export const {
  clearSearchProducts,
} = collectionEditSlice.actions;

export default collectionEditSlice.reducer;
